import { siteX } from "../interceptors/api";
const getAll = (query) => siteX.post("clients/get-all", query);
const getById = (id) => siteX.get(`clients/${encodeURIComponent(id)}`);
const create = (command) => siteX.post("clients/create", command);
const update = (command) => siteX.put("clients/update", command);
const remove = (id) => siteX.delete(`clients/${encodeURIComponent(id)}`);
/** All clients (id + name). */
const getOptions = () => siteX.get("clients/options");
/** The locations of one client (id + name). */
const getLocationOptions = (clientId) => siteX.get(`clients/${encodeURIComponent(clientId)}/locations`);
/** Every location of every client, labelled "Location (Client)" (AP list filter). */
const getAllLocationOptions = () => siteX.get("clients/locations");
export const clientsApi = { getAll, getById, create, update, remove, getOptions, getLocationOptions, getAllLocationOptions };
/** The message of a failed API call (the API returns a ResponseDto body with message on 4xx). */
export const apiErrorMessage = (error, fallback) => { var _a, _b; return ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || (error === null || error === void 0 ? void 0 : error.message) || fallback; };
